import { RegionsFieldsFragment, ThemesFieldsFragment } from 'api/graphql-types';
import { Icon } from 'components/icon/icon';
import { NextLink } from 'components/next-link';
import { Typography } from 'components/typography';

import IcnCarotRight from 'public/assets/icons/carot-right.svg';

import styles from './categories.module.scss';
import { iterateHeading } from 'utils/iterate-heading';

export type ICategoriesProps =
	| {
			module: RegionsFieldsFragment;
	  }
	| {
			module: ThemesFieldsFragment;
	  };

const Categories = (props: ICategoriesProps): React.JSX.Element => {
	let categories;

	if ('regions' in props.module) {
		categories = props.module.regions;
	} else if ('themes' in props.module) {
		categories = props.module.themes;
	}

	return (
		<div className={styles.content}>
			{props.module.title?.value && (
				<Typography tag={props.module.title?.type || 'h2'} variant="h2" className={styles.title}>
					{props.module.title?.value}
				</Typography>
			)}

			<div className={styles.cards}>
				{categories?.map((category, index) => {
					return (
						<NextLink legacyBehavior href={category.data.attributes.slug} key={index}>
							<a className={styles.card}>
								<div className={styles.header}>
									<span className={styles.icon}>
										<Icon customIcon={<IcnCarotRight />} size="12px" />
									</span>
									{category?.data?.attributes?.title && (
										<Typography
											tag={iterateHeading(props.module.title?.type) || 'div'}
											variant="h3"
											className={styles.cardTitle}
										>
											{category.data.attributes?.title}
										</Typography>
									)}
								</div>
								{category?.data?.attributes?.header?.description && (
									<div className={styles.description}>{category?.data?.attributes?.header?.description}</div>
								)}
							</a>
						</NextLink>
					);
				})}
			</div>
		</div>
	);
};

export default Categories;
